import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import BaseRegulation from '../base_regulation';
import LastLoginCompositeController from '../../../../components/regulation_components/base/last_login/last_login_composite_controller';
import SessionTimerController from '../../../../components/session_timer/session_timer_controller';
import LastLoginComponentController from '../../../../components/regulation_components/base/last_login/last_login_component_controller';
import NetherlandsResponsibleGamingIconsController from "../../../../components/regulation_components/netherlands/responsible_gaming_icons/netherlands_responsible_gaming_icons_controller";

interface AccountData {
    RegulationStatusId: number,
}

const RegulationStatusIdMap = {
    ApprovedForRegulation: 0,
    PendingDocuments: 2
};

export default class NetherlandsRegulation extends BaseRegulation {
    static CLASS = 'NetherlandsRegulation';

    private _selfTestLink: string = "";

    /**
     *
     * @param params
     */
     init(params) {
        super.init(params);

        params = params || {};
        this._selfTestLink = params.selfTestLink;
    }

    private _getAccountData(): AccountData {
        return this.serviceFactory.userService().getAccountData() as AccountData;
    }

    isAnonymousPlayAllowed() : boolean {
        if(!this.serviceFactory.oAuth2Service().isAuthorized()) {
            return false;
        }

        return this._getAccountData().RegulationStatusId === RegulationStatusIdMap.ApprovedForRegulation;
    }

    openSelfTest(view) {
        this._sendAnalytics('SelfTest', view);
        this.serviceFactory.openLinkService().openLink({
            sourceLink: this._selfTestLink,
            view,
        });
    }


    shouldShowPlayerLimitsToaster(): boolean {
        return true;
    }

    _sendAnalytics(action, value) {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Regulation',
            action: action,
            label: 'Netherlands',
            value: value
        });
    }

    getExternalLinksConfig() {
        return {
            'membership': {
                isCloseBtnAllowed: false
            },
            'upload_document': {
                isCloseBtnAllowed: false
            },
            'pending_play': {
                isCloseBtnAllowed: false
            }

        };
    }

    sessionTimerEnabled() {
        return true;
    }

    sessionTimerVisible() {
        return true;
    }

    getLastLoginComponent(params) {
        let lastLoginComponent = LastLoginComponentController.create(params);
        let sessionTimerComponent = SessionTimerController.create();
        return LastLoginCompositeController.create({lastLoginComponent: lastLoginComponent, sessionTimerComponent: sessionTimerComponent});
    }

    showResponsibleIcons() {
        return true;
    }

    showAgeResponsibleIconInGame() {
        return true;
    }

    showAgeResponsibleGameInDetailedHistory() {
        return true;
    }

    getResponsibleGamingIconsComponent(params){
        return NetherlandsResponsibleGamingIconsController.create(params);
    }

    getAgeResponsibleGamingLabel() {
        return this.serviceFactory.languageService().translation('responsible_gaming_age_label');
    }
}
